/** Redes oficiales Gold Loterías. */
export const OFFICIAL_SOCIAL_LINKS = [
  {
    label: "Instagram",
    url: "https://www.instagram.com/goldloterias/",
    icon_key: "instagram",
  },
  {
    label: "Facebook",
    url: "https://www.facebook.com/931649740031966",
    icon_key: "facebook",
  },
  {
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/goldloterias/",
    icon_key: "linkedin",
  },
];
